export const formatPercent = (number, $show_symbol = true) => {

    if (number === "") return number;

    if ($show_symbol) {
        return (parseFloat(number) * 100).toFixed(2).toString().replace('.', ',')+'%';
    }
    return (parseFloat(number) * 100).toFixed(2).toString().replace('.', ',');
}